<template>
  <v-text-field :id="id" v-model="generatedPassword" readonly>
    <template v-slot:prepend>
      <v-btn flat @click="generatePassword">Generuj hasło</v-btn>
    </template>

    <template v-slot:append>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn flat small @click="copy" v-on="on">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>

        <span> Kopiuj </span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
import { generate } from 'generate-password';

// @vuese
// Komponent generowania hasła
// @group forms
export default {
  data() {
    return {
      generatedPassword: '',
      id: 'generated_' + Math.floor(Math.random() * 10000)
    };
  },

  methods: {
    // @vuese
    // Generowanie hasła
    generatePassword() {
      this.generatedPassword = generate({
        length: Math.floor(Math.random() * 2) + 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true,
        exclude: '()+_-=}{[]|:;"?.><,`~/'
      });
      this.$emit('generated', this.generatedPassword);
    },
    // @vuese
    // Kopiowanie wygenerowanego hasła
    copy() {
      const el = document.getElementById(this.id);
      el.select();
      document.execCommand('copy');
    }
  }
};
</script>
